/*
 * Public API Surface of ngx-scroll-position-restoration
 */

export * from './lib/ngx-scroll-position-restoration.module';
export * from './lib/ngx-scroll-position-restoration-config';
export * from './lib/custom-router-outlet.directive';
